<template>
  <div>
    <v-menu
      v-model="menu2"
      :close-on-content-click="false"
      :nudge-right="40"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <div v-on="on">
          <slot></slot>
        </div>
      </template>
      <v-date-picker v-model="date" @input="onInput"></v-date-picker>
    </v-menu>
  </div>
</template>

<script>
export default {
  props: ["value"],
  data() {
    return {
      date: this.value,
      menu2: false,
    };
  },
  methods: {
    onInput(date) {
      this.menu2 = false;

      this.$emit("input", date);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>